<template>
  <div
    class="CardInfoComponent"
    :class="type"
  >
    <div class="icon">
      <i
        :class="icon"
        aria-hidden="true"
      ></i>
    </div>
    <div
      class="text preline"
      :style="`text-align: ${textAlign}`"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
  defineProps({
    icon: {
      type: String,
      default: 'icon-informacion'
    },
    type: {
      type: String,
      default: undefined
    },
    textAlign: {
      type: String,
      default: 'center'
    }
  })
</script>

<style lang="scss" scoped>
  .CardInfoComponent {
    display: flex;
    padding: $spacing-l;
    margin: $spacing-l 0 $spacing-xl;
    align-items: center;
    gap: $spacing-l;
    background-color: $color-primary-lighter;
    font-family: $font-family-primary;
    font-size: $font-size-s;
    font-style: normal;
    font-weight: $font-weight-400;
    line-height: $line-height-140p;
    color: $color-primary;

    .icon {
      align-self: flex-start;
      font-family: $font-family-icons;
      font-size: $font-size-xl;
    }

    .preline {
      white-space: pre-line;
    }
  }
</style>
